import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import {
  initCustomerInfo,
  setState,
  searchCustomerByCustNo,
  updateCustomerInfo,
  renewCustomerJobAndDriver,
  postSuitability,
  chkCertiSms,
  verifySmsAuthNo,
  retrySmsAuthNo,
  verifyName,
  checkIdentityCard,
  saveSignNameData,
  saveSignatureData,
  sendTestSms,
  getSuitabilityTestHistory,
  getSuitabilityKeys,
  postSuitabilityReport,
  updateOriginCustomerInfo,
  setState as setCustomerState,
  searchCustomerRelationList,
  addCustomerRelation,
  deleteCustomerRelation,
  setCustomerFamilyHead,
  checkEmailCompare,
  sendPlanAgreeSmsByCustNo,
  updateCorporationInfo,
  sendCustomerInfoModifyUrl,
  getCustomerPreviousData,
  updateCustomerInfoError,
  renewCustomerInfo,
} from '@store/actions/customerAction';
import { showModal, saveInProgress } from '@store/actions/commonAction';
import {
  PinnedCustomerStatus,
  DetailInfo,
  RegisterInfo,
  ContactInfo,
  CorporateContactInfo,
  AddressInfo,
  CorporateAddressInfo,
  SuitabilityField,
  InvitationReceive,
  FamilyMemberInfo,
  FamilyMemberAdd,
  CorporateMemberAddPopup,
  CustomerInfoRenew,
  CorporationDetailInfo,
  CorporationInfo,
  FinanceCustomer,
  CorporateContractInquiryManagerInfo,
  CorporateMemberDocumentInfo,
  CorporateMemberInfo,
  CustomerInfoPlanHistory,
  CustomerInfoContract,
  CustomerInfoShortCut,
  PfmsContents,
} from '@container/customer';
import SatModal from '@components/common/satUI/SatModal';
import { toPhone } from '@common/utils/validation';

const stateSelector = createSelector(
  state => state.customerReducer,
  state => state.userReducer,
  state => state.commonReducer,
  (customerReducer, userReducer, commonReducer) => ({
    customerInfo: customerReducer.customerInfo,
    originCustomerInfo: customerReducer.originCustomerInfo,
    redience: customerReducer.customerInfo?.redience ?? {}, // 기계약자 레디언스 정보
    customerRelationList: customerReducer.customerRelationList, // 가족구성원
    userInfo: userReducer.userInfo,
    channelInfo: userReducer.channelInfo,
    inProgress: commonReducer.inProgress,
    errorObj: customerReducer.errorObj ?? {}, // 입력값 에러정보
  }),
);

/* @NOTE: 고객정보의 clientId를, redience 노드를 참조하는 항목에 대한 설명 */
// 고객정보에서 clientId를 내려주지 않고,
// 기계약고객인 경우, redience 정보로 고객정보를 서버단에서 업데이트해서 내려줌으로,
// redience 노드를 참조하는 값들은 실제로 사용되지 않음
const CustomerInfo = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { confirm } = $hooks.useModal();
  const {
    customerInfo,
    originCustomerInfo,
    userInfo,
    customerRelationList,
    redience,
    inProgress,
    errorObj,
  } = useSelector(stateSelector);

  const isLP = $utils.checkLP(customerInfo?.orgChnlCd);
  const isPfms = (customerInfo?.pfmsYn == 'Y' && isLP) ? true : false;

  const isContractCustomer =
    customerInfo &&
    ((customerInfo.custKind === 'P' && customerInfo?.policyType !== '가망') ||
      (customerInfo.custKind === 'C' &&
        customerInfo.corporation?.policyType !== '가망')); // hanjy: 법인일 경우 추가

  const { error: toastError } = $hooks.useToast();
  const { isRestrictedUser, tokenInfo} = $hooks.useUser();

  const isHelpDesk = $utils.isHelpDesk(tokenInfo);

  const roleForPfmsPage = $utils.roleForPfmsPage(tokenInfo);

  const { alertAndShowJobDriverPopup, updateCustomerJobDriver } =
    $hooks.useCustomer();

  const [isOwnCustomer, setIsOwnCustomer] = useState(false); // 고객이 기계약자인지 여부
  const [isOpenFamilyAddPopup, setIsOpenFamilyAddPopup] = useState(false); // 가족구성원 추가 팝업
  const [isOpenCorporateMemberAddPopup, setIsOpenCorporateMemberAddPopup] =
    useState(false); // 법인구성원 추가 팝업
  const [isOpenRenewdPopup, setIsOpenRenewdPopup] = useState(false); // 가입 설계 동의 갱신 팝업
  // Robin - 직업/운전정보 이상 여부 확인
  const [isCheckedJobDrvError, setIsCheckedJobDrvError] = useState(false);

  // 화면 최초 진입 시 수행
  const initPage = () => {
    const custNo = history.location.state?.custNo;
    const cb = customer => {
      console.log('### callback');
      dispatch(updateOriginCustomerInfo(customer));
    };

    if (custNo) {
      dispatch(
        searchCustomerByCustNo({
          custNo,
          callback: cb,
          // 고객 정보 불러오는데 실패할 경우 처리
          errorCallback: () => {
            toastError(
              '고객 정보를 불러오는데 실패하였습니다. 다른 고객을 선택해주세요.',
            );
            history.push('/home/main');
          },
          searchRelation: true,
        }),
      );

      // 기등록된 고객정보(주소/이메일) 불러오기
      dispatch(getCustomerPreviousData({ custNo }));
    } else if (customerInfo) {
      // 이미 고객정보가 있는 경우 (뒤로가기 등으로 진입한 경우)
      const custNo = customerInfo?.custNo;
      const custKind = customerInfo?.custKind;

      // 가입설계에서 가족 관계 정보 업데이트 될 수 있어 재로딩
      dispatch(searchCustomerRelationList({ custNo, custKind }));

      // 가입설계에서 갱신한 직업/운전정보가 있을 수 있어 해당 부분만 업데이트 처리
      dispatch(renewCustomerJobAndDriver({ custNo }));

      // 기등록된 고객정보(주소/이메일) 불러오기
      dispatch(getCustomerPreviousData({ custNo }));
    } else {
      toastError('고객 정보를 찾을 수 없습니다. 먼저 고객을 선택해주세요.');
      history.push('/home/searchCustomer');
    }
  };

  // 고객 정보 유효성 체크
  const checkCustomerValidation = () => {
    const isCorporate = $utils.checkCorporate(customerInfo);

    if (isCorporate) {
      // 법인정보 이상 여부 확인
      const isValidCorporation = $utils.checkValidCorporation(customerInfo);
      dispatch(updateCustomerInfoError({ corporation: !isValidCorporation }));
    }

    // 고객 정보 유효성 체크
    // 주소 유효성 체크
    const isValidAddress = $utils.checkValidAddress(customerInfo);
    dispatch(updateCustomerInfoError({ address: !isValidAddress }));

    // 우편물 수령처 체크
    const isValidPostPlace = $utils.checkValidPostPlace(customerInfo);
    dispatch(updateCustomerInfoError({ postPlace: !isValidPostPlace }));

    // 외국인/외국법인 여부와 영문명 체크
    const isValidForeignerData = $utils.checkValidForeigner(customerInfo);
    dispatch(updateCustomerInfoError({ foreigner: !isValidForeignerData }));
  };

  // 직업/운전 코드 확인 [직업/운전 코드 유효성은 최초 1회/저장 버튼 클릭 시 확인]
  const handleCheckJobDriver = () => {
    // 직업 운전정보 확인 여부 [중복 확인 방지용]
    setIsCheckedJobDrvError(true);

    const isValidJobDriver = $utils.checkValidJobDriver(customerInfo);
    if (!isValidJobDriver) {
      return alertAndShowJobDriverPopup(customerInfo, {
        onOk: updateCustomerJobDriver,
      });
    }
  };

  useEffect(initPage, []);

  useEffect(() => {
    if (customerInfo) {
      let array = [...inProgress];
      if (JSON.stringify(customerInfo) === JSON.stringify(originCustomerInfo)) {
        array = array.filter(item => item !== '/home');
      } else {
        array = array.concat('/home');
      }

      dispatch(saveInProgress([...new Set(array)]));
      // 기계약자 여부
      setIsOwnCustomer(getIsOwnCustomer(customerInfo?.clientId));

      // 고객 정보 유효성 체크
      checkCustomerValidation();

      // 고객 직업/운전정보 최초 1회 확인
      if (!isCheckedJobDrvError) handleCheckJobDriver();
    }
  }, [customerInfo]);

  // 본인고객대상여부
  const getIsOwnCustomer = clientId => (clientId ? true : false);

  // 안내장수신여부
  const getInvitationReceiveYnValues = (emailYn, mobileYn) => {
    let invitationReceiveYnValues = [];
    if (emailYn === 'Y') invitationReceiveYnValues.push('email');
    if (mobileYn === 'Y') invitationReceiveYnValues.push('mobile');
    return invitationReceiveYnValues;
  };

  // 연락처정보
  const getContactInfo = (
    (customerInfo, redience, isOwnCustomer) => property => {
      if (customerInfo.custKind === 'C') {
        // 법인 고객
        switch (property) {
          case 'officeTel':
            return isOwnCustomer
              ? customerInfo.corporation?.redience?.officeTel
              : customerInfo.corporation?.telNo;
          case 'email':
            return isOwnCustomer
              ? customerInfo.corporation?.redience?.email
              : customerInfo.corporation?.email;
          case 'faxNo':
            return isOwnCustomer
              ? customerInfo.corporation?.redience?.officeFax
              : customerInfo.corporation?.faxNo;
          default:
            return '';
        }
      }

      switch (property) {
        case 'mobileTelNo':
          return isOwnCustomer ? redience.cpNo : customerInfo.mobileTelNo;
        case 'emailAddr':
          return isOwnCustomer ? redience.email : customerInfo.emailAddr;
        case 'homeTelNo':
          return isOwnCustomer ? redience.homeTel : customerInfo.homeTelNo;
        case 'wkplTelNo':
          return isOwnCustomer ? redience.officeTel : customerInfo.wkplTelNo;
        default:
          return '';
      }
    }
  )(customerInfo, redience, isOwnCustomer);

  const handleClearCustomerInfo = () => {
    if (inProgress.includes('/home')) {
      dispatch(
        showModal({
          visible: true,
          type: 'confirm',
          msg: '수정중인 고객정보가 저장되지 않았습니다. 그래도 이동하시겠어요?',
          onOk: {
            label: '예',
            handle: () => {
              dispatch(initCustomerInfo());
              dispatch(
                saveInProgress(inProgress.filter(item => item !== '/home')),
              );
            },
          },
          onCancel: { label: '아니요' },
        }),
      );
    } else {
      dispatch(
        showModal({
          visible: true,
          type: 'confirm',
          msg: `${customerInfo.name}님의 업무를 진행중입니다. 업무를 종료하시겠어요?`,
          onOk: {
            label: '예',
            handle: () => {
              dispatch(initCustomerInfo());
              history.push('/home/main');
            },
          },
          onCancel: { label: '아니요' },
        }),
      );
    }
  };

  const handleCustomerInfo = object => {
    dispatch(updateCustomerInfo(object));
    if ('emailAddr' in object) {
      // 이메일, 담당 설계자 이메일과 비교
      dispatch(
        checkEmailCompare({
          email: object.emailAddr,
          custNo: customerInfo.custNo,
          callback: checkEmailCompareSuccessCallback,
        }),
      );
    }
  };

  const checkEmailCompareSuccessCallback = data => {
    // LP/FP 본인 청약일때는 이메일 검증 하지 않음
    if (data.lpGaContract) {
      dispatch(updateCustomerInfoError({ email: false }));
      return;
    }

    if (data.checkEmailAllYn) {
      // 이메일주소 전체가 동일한 경우
      dispatch(updateCustomerInfoError({ email: true }));
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: `계약자의 이메일 주소와 담당 보험설계사의 이메일 주소(${data.email})가 동일해요. 이메일 주소를 다시 입력해주세요.`,
          onOk: {
            label: '확인',
          },
        }),
      );
    } else if (data.checkEmailIdYn) {
      // 이메일주소 앞부분이 동일한 경우
      dispatch(
        showModal({
          visible: true,
          type: 'confirm',
          msg: `계약자의 이메일 주소 ID와 담당 보험설계사의 이메일 주소 ID(${data.email.substring(
            0,
            data.email.indexOf('@'),
          )})가 동일해요. 진행하시겠어요?`,
          onOk: {
            label: '예',
            handle: () => {
              dispatch(updateCustomerInfoError({ email: false }));
            },
          },
          onCancel: {
            label: '아니오',
            handle: () => {
              dispatch(updateCustomerInfoError({ email: true }));
            },
          },
        }),
      );
    } else {
      dispatch(updateCustomerInfoError({ email: false }));
    }
  };

  const handleUpdateMobileTelNo = payload => {
    const data = Object.assign(customerInfo, payload);
    const originData = Object.assign(originCustomerInfo, payload);
    dispatch(updateOriginCustomerInfo(originData));

    if (inProgress.includes('/home')) {
      dispatch(updateCustomerInfo(data));
    }
  };

  // 가족구성원 수정 콜백
  const handleChangeMemberListCallback = result => {
    if (result)
      dispatch(
        searchCustomerRelationList({
          custNo: customerInfo.custNo,
          custKind: customerInfo.custKind,
        }),
      );
  };

  // 가족 대표자 지정
  const handleSetFamilyHead = custNo => {
    dispatch(
      setCustomerFamilyHead({
        custNo: custNo,
        myCustNo: customerInfo.custNo,
        callback: handleChangeMemberListCallback,
      }),
    );
  };

  // 가족구성원 제거
  const handleRemoveMember = (custNo, relationCode) => {
    dispatch(
      deleteCustomerRelation({
        custNo: custNo,
        myCustNo: customerInfo.custNo,
        custKind: customerInfo.custKind,
        relationCode: relationCode,
        callback: handleChangeMemberListCallback,
      }),
    );
  };

  // 구성원 추가
  const handleAddMember = (custNo, relationCode) => {
    dispatch(
      addCustomerRelation({
        custNo: custNo,
        myCustNo: customerInfo.custNo,
        custKind: customerInfo.custKind,
        relationCode: relationCode,
        callback: handleChangeMemberListCallback,
      }),
    );
  };

  //갱신 팝업 닫기
  const handleCloseRenewPopup = isUpdated => {
    setIsOpenRenewdPopup(false);

    if (isUpdated) {
      const cb = customer => {
        dispatch(
          renewCustomerInfo({
            customerInfo: customer,
            originCustomerInfo: customer,
          }),
        );
      };

      dispatch(
        searchCustomerByCustNo({
          custNo: customerInfo.custNo,
          callback: cb,
          searchRelation: true,
        }),
      );
    }
  };

  // 고객 정보 변경 SMS 발송
  const handleSendPlanAgreeSms = (custNo, mobileTelNo) => {
    dispatch(sendPlanAgreeSmsByCustNo({ custNo, mobileTelNo }));
  };

  // 고객 정보 변경 URL SMS 발송
  const handleSendCustomerInfoModifyUrl = object => {
    const custNo = object.custNo;
    const mobileTelNo = object.mobileTelNo
    if (mobileTelNo.length < 9) return;
    dispatch(sendCustomerInfoModifyUrl({ custNo, mobileTelNo }));
    object.callback();
  };

  // 법인 고객정보 수정
  const handleCorporationInfo = object => {
    dispatch(updateCorporationInfo(object));

    if ('email' in object) {
      // 이메일, 담당 설계자 이메일과 비교
      dispatch(
        checkEmailCompare({
          email: object.email,
          custNo: customerInfo.custNo,
          callback: checkEmailCompareSuccessCallback,
        }),
      );
    }
  };

  const handleUpdateFinanceInfo = ({
    specialFinanceCustTypeCode,
    generalFinanceCustomerYN,
  }) => {
    dispatch(
      setState({
        customerInfo: Object.assign({}, customerInfo, {
          corporation: Object.assign({}, customerInfo.corporation, {
            specialFinanceCustTypeCode,
            generalFinanceCustomerYN,
          }),
        }),
        originCustomerInfo: Object.assign({}, originCustomerInfo, {
          corporation: Object.assign({}, originCustomerInfo.corporation, {
            specialFinanceCustTypeCode,
            generalFinanceCustomerYN,
          }),
        }),
      }),
    );
  };

  return (
    customerInfo && (
      <React.Fragment>
        <div className="vbox">
          <div className="custom-sch-box">
            <PinnedCustomerStatus
              name={customerInfo.name}
              rsdn={customerInfo.rsdn}
              genderLabel={customerInfo.genderLabel}
              custKind={customerInfo.custKind}
              onClear={handleClearCustomerInfo}
            />
          </div>
          <div className="app-box">
            {/* 고객정보 */}
            {customerInfo.custKind === 'P' && (
              <DetailInfo
                customerInfo={customerInfo}
                onChange={handleCustomerInfo}
              />
            )}
            {/* 법인정보 */}
            {customerInfo.custKind === 'C' && (
              <CorporationInfo
                customerInfo={customerInfo}
                onChange={handleCorporationInfo}
              />
            )}
          </div>
          {/* 바로가기 start */}
          <CustomerInfoShortCut customerInfo={customerInfo} />
          {/* 바로가기 end */}

          {customerInfo.custKind === 'C' && (
            /* 법인 상세정보 */
            <div className="app-box">
              <CorporationDetailInfo
                customerInfo={customerInfo}
                onChange={handleCorporationInfo}
              />
            </div>
          )}

          <div className="app-box">
            {/* 가입설계동의 */}
            {customerInfo.custKind === 'P' && (
              <RegisterInfo
                agreeDate={customerInfo.agreeDate}
                agreeStatusText={customerInfo.agreeStatusText}
                customerInfo={customerInfo}
                agreeDeleteDate={customerInfo.agreeDeleteDate}
                isOwnCustomer={isOwnCustomer}
                legalAge={customerInfo.legalAge}
                customerName={customerInfo.name}
                custNo={customerInfo.custNo}
                mobileTelNo={getContactInfo('mobileTelNo')}
                sendPlanAgreeSms={handleSendPlanAgreeSms}
                onClickRenewPopup={() => setIsOpenRenewdPopup(true)}
              />
            )}

            {/* 일반 / 전문금융 소비자 여부(법인) */}
            {customerInfo.custKind === 'C' && (
              <FinanceCustomer
                customerInfo={customerInfo}
                updateCustomerInfo={handleUpdateFinanceInfo}
              />
            )}

            {/* 연금정보수집동의 */}
            {(isPfms || roleForPfmsPage) && (
              <PfmsContents
                pfmUpddtm={customerInfo.pfmUpddtm}
                pfmsAgreStrtDd ={customerInfo.pfmsAgreStrtDd}
                customerInfo={customerInfo}
                agreeDeleteDate={customerInfo.agreeDeleteDate}
              />
            )}

            {/* 외화보험적합성진단 */}
            {!isRestrictedUser && (
              <SuitabilityField
                type="currency"
                userInfo={userInfo}
                customerInfo={customerInfo}
                updateCustomerInfo={handleUpdateMobileTelNo}
                postSuitability={payload => dispatch(postSuitability(payload))}
                chkCertiSms={payload => dispatch(chkCertiSms(payload))}
                verifySmsAuthNo={payload => dispatch(verifySmsAuthNo(payload))}
                retrySmsAuthNo={payload => dispatch(retrySmsAuthNo(payload))}
                verifyName={payload => dispatch(verifyName(payload))}
                checkIdentityCard={payload =>
                  dispatch(checkIdentityCard(payload))
                }
                saveSignNameData={payload =>
                  dispatch(saveSignNameData(payload))
                }
                saveSignatureData={payload =>
                  dispatch(saveSignatureData(payload))
                }
                sendTestSms={payload => dispatch(sendTestSms(payload))}
                showModal={payload => dispatch(showModal(payload))}
                getSuitabilityTestHistory={payload =>
                  dispatch(getSuitabilityTestHistory(payload))
                }
                getSuitabilityKeys={payload =>
                  dispatch(getSuitabilityKeys(payload))
                }
                postSuitabilityReport={payload =>
                  dispatch(postSuitabilityReport(payload))
                }
                searchCustomerByCustNo={payload =>
                  dispatch(searchCustomerByCustNo(payload))
                }
                setCustomerState={payload =>
                  dispatch(setCustomerState(payload))
                }
              />
            )}

            {/* 변액보험적합성진단 */}
            {!isRestrictedUser && (
              <SuitabilityField
                type="variable"
                userInfo={userInfo}
                customerInfo={customerInfo}
                updateCustomerInfo={handleUpdateMobileTelNo}
                postSuitability={payload => dispatch(postSuitability(payload))}
                chkCertiSms={payload => dispatch(chkCertiSms(payload))}
                verifySmsAuthNo={payload => dispatch(verifySmsAuthNo(payload))}
                retrySmsAuthNo={payload => dispatch(retrySmsAuthNo(payload))}
                verifyName={payload => dispatch(verifyName(payload))}
                checkIdentityCard={payload =>
                  dispatch(checkIdentityCard(payload))
                }
                saveSignNameData={payload =>
                  dispatch(saveSignNameData(payload))
                }
                saveSignatureData={payload =>
                  dispatch(saveSignatureData(payload))
                }
                sendTestSms={payload => dispatch(sendTestSms(payload))}
                showModal={payload => dispatch(showModal(payload))}
                getSuitabilityTestHistory={payload =>
                  dispatch(getSuitabilityTestHistory(payload))
                }
                getSuitabilityKeys={payload =>
                  dispatch(getSuitabilityKeys(payload))
                }
                postSuitabilityReport={payload =>
                  dispatch(postSuitabilityReport(payload))
                }
                searchCustomerByCustNo={payload =>
                  dispatch(searchCustomerByCustNo(payload))
                }
                setCustomerState={payload =>
                  dispatch(setCustomerState(payload))
                }
              />
            )}
          </div>

          <div className="app-box">
            {/* 연락처 */}
            {customerInfo?.custKind === 'C' ? (
              <>
                <CorporateContactInfo
                  telNo={getContactInfo('officeTel')}
                  email={getContactInfo('email')}
                  faxNo={getContactInfo('faxNo')}
                  customerInfo={customerInfo}
                  isOwnCustomer={isOwnCustomer}
                  errorObj={errorObj}
                  onChange={handleCorporationInfo}
                />

                {/* 우편물 수령처 */}
                <CorporateAddressInfo
                  customerInfo={customerInfo}
                  corporation={customerInfo.corporation}
                  isOwnCustomer={isOwnCustomer}
                  onChange={handleCorporationInfo}
                />
              </>
            ) : (
              <>
                <ContactInfo
                  customerInfo={customerInfo}
                  mobileTelNo={getContactInfo('mobileTelNo')}
                  emailAddr={getContactInfo('emailAddr')}
                  homeTelNo={getContactInfo('homeTelNo')}
                  wkplTelNo={getContactInfo('wkplTelNo')}
                  beforeCustomerInfoDTO={customerInfo?.beforeCustomerInfoDTO}
                  isOwnCustomer={isOwnCustomer}
                  errorObj={errorObj}
                  onChange={handleCustomerInfo}
                  sendCustomerInfoModifyUrl={handleSendCustomerInfoModifyUrl}
                />

                {/* 우편물수령처 */}
                <AddressInfo
                  customerInfo={customerInfo}
                  redience={redience}
                  isOwnCustomer={isOwnCustomer}
                  onChange={handleCustomerInfo}
                />
              </>
            )}

            {/* 안내장 수신 여부 본인고객에 한함 */}
            {isContractCustomer && (
              <InvitationReceive
                invitationReceiveYnValues={getInvitationReceiveYnValues(
                  customerInfo?.custKind === 'C'
                    ? customerInfo.corporation?.redience?.emailNoticeYn
                    : redience.emailNoticeYn,
                  customerInfo?.custKind === 'C'
                    ? customerInfo.corporation?.redience?.enoticeYn
                    : redience.enoticeYn,
                )}
                // onChange={handleCustomerInfo}
              />
            )}
          </div>

          {/* <!-- 법인계약 조회 관리인 --> */}
          {customerInfo?.custKind === 'C' && (
            <CorporateContractInquiryManagerInfo customerInfo={customerInfo} />
          )}

          {/* <!-- 법인고객 제출 서류 --> */}
          {customerInfo?.custKind === 'C' && isLP && isContractCustomer && (
            <CorporateMemberDocumentInfo
              documentList={customerInfo.corporation?.oasis}
            />
          )}

          {/* <!-- 법인구성원 정보 / 가족구성원 정보  --> */}
          {customerInfo?.custKind === 'C' ? (
            <CorporateMemberInfo
              corporateRelationList={customerRelationList}
              onClickRemoveCorporateMember={handleRemoveMember}
              onClickAddCorporateMember={() =>
                setIsOpenCorporateMemberAddPopup(true)
              }
            />
          ) : (
            <FamilyMemberInfo
              customerRelationList={customerRelationList}
              onClickSetFamilyHead={handleSetFamilyHead}
              onClickRemoveFamily={handleRemoveMember}
              onClickAddFamily={() => setIsOpenFamilyAddPopup(true)}
            />
          )}

          {/* 계약 정보 */}
          {/* 계약정보는 계약 고객일 경우만 노출 */}
          {$utils.checkContractCustomer(customerInfo) && (
            <CustomerInfoContract customer={customerInfo} />
          )}

          {/* 가입설계이력 */}
          <CustomerInfoPlanHistory customer={customerInfo} />
        </div>

        <SatModal
          visible={isOpenFamilyAddPopup}
          wide
          setVisible={() => setIsOpenFamilyAddPopup(false)}
        >
          <FamilyMemberAdd
            title={'가족구성원 추가'}
            currentCustNo={customerInfo.custNo}
            addFamilyMember={handleAddMember}
            onCloseModal={() => setIsOpenFamilyAddPopup(false)}
          />
        </SatModal>

        <SatModal
          visible={isOpenCorporateMemberAddPopup}
          wide
          setVisible={() => setIsOpenCorporateMemberAddPopup(false)}
        >
          <CorporateMemberAddPopup
            title={'법인구성원 추가'}
            currentCustNo={customerInfo.custNo}
            addCorporateMember={handleAddMember}
            onCloseModal={() => setIsOpenCorporateMemberAddPopup(false)}
          />
        </SatModal>

        {/* 고객 정보 갱신 팝업 */}
        <SatModal visible={isOpenRenewdPopup} type="fullPop">
          <CustomerInfoRenew
            title={'가입설계 동의'}
            customerInfo={customerInfo}
            onCloseModal={handleCloseRenewPopup}
          />
        </SatModal>
      </React.Fragment>
    )
  );
};

export default CustomerInfo;
